// src/pages/Marketplace/shared/constants.ts
// MIRROR of backend/lambdas/shared/surge/constants.py — keep in sync.
// If the Lambda layer changes these values, update here too and bump a note in the spec.
// Source of truth: docs/superpowers/specs/2026-04-07-surge-pricing-multiplier-design.md §3
// "Day-of-week multiplier constants".
export const BASE_PRICE_CENTS = 900;

export const SURGE_DAY_OF_WEEK: Record<number, number> = {
  // 0 = Monday ... 6 = Sunday (Python datetime.weekday() convention used by the shared layer)
  0: 1.0,   // Monday
  1: 1.0,   // Tuesday
  2: 1.0,   // Wednesday
  3: 1.5,   // Thursday
  4: 2.5,   // Friday
  5: 3.0,   // Saturday
  6: 1.3,   // Sunday
};

export const DAY_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] as const;
